<template>
  <div class="footer-bar">
    <div class="footer-bar-container">
      <div class="footer-bar-row ismobilelogo">
        <a href="https://www.simplybrand.com/"><img src="@/assets/img/logo-bottom.png"></a>
        <p>{{ $t('LandingPage.footerabout') }}</p>
      </div>
      <div class="footer-bar-row ismobilerow">
        <h2>{{ $t('LandingPage.ProductFeatures') }}</h2>
        <ul>
          <li><a href='#goto4'>{{ $t('SidebarMenu.Menu06') }}</a></li>
          <li><a href='#goto3'>{{ $t('SidebarMenu.Menu05') }}</a></li>
          <li><a href='#goto2'>{{ $t('SidebarMenu.Menu04') }}</a></li>
          <li><a href='#goto1'>{{ $t('SidebarMenu.Menu01') }}</a></li>
        </ul>
      </div>
       <div class="footer-bar-row ismobilerow">
        <!--<h2>{{ $t('PageCommon.HelpCenter') }}</h2>
        <ul>
          <li><router-link to="/Help/OperationManual">{{ $t('PageCommon.zhinan') }}</router-link></li>
          <li><router-link to="/Help/FAQ">{{ $t('PageCommon.faq') }}</router-link></li>
        </ul>-->
      </div> 
      <div class="footer-bar-row ismobilerow">
        <h2>{{ $t('PageCommon.Contact') }}</h2>
        <ul>
          <li>{{ $t('PageCommon.email') }}：contact@simplybrand.com</li>
          <li>{{ $t('PageCommon.address') }}：{{ $t('PageCommon.address1') }}</li>
          <li>{{ $t('PageCommon.address2') }}</li>
        </ul>
      </div>
    </div>
    <FooterBarCopyRight />
    <!-- <remote-js></remote-js> -->
  </div>
</template>

<style scoped>
.footer-bar{
  padding-left: 15px;
  padding-right: 15px;
  background-color: #252B3A;
}
@media (min-width: 1170px) {
  .footer-bar-container{
    width: calc(100% - 266px);
    margin: auto; 
  }
}
@media (max-width: 765px) {
  .ismobilelogo.footer-bar-row{
    width: 100%;
    padding: 0;
    padding-top: 70px;
  }
  .ismobilerow.footer-bar-row{
    width: 33.33333333%;
    padding: 15px 15px 15px 0px;
  }
}
.footer-bar-row{
  width: 25%;
  float: left;
  padding: 70px 50px 70px 0;
}
.footer-bar-container:before,
.footer-bar-container:after,
.footer-bar-row:before,
.footer-bar-row:after{
  content: '';
  display: table;
}
.footer-bar-container:after,
.footer-bar-row:after{
  clear: both;
}
h2{
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  line-height: 48px;
  /* border-bottom: 1px solid rgba(153,153,153,0.50); */
}
ul{
  padding: 0;
  margin: 0;
}
ul > li{
  font-size: 12px;
  line-height: 18px;
  color: rgba(255,255,255,0.50);
  list-style: none;
  margin-top: 10px;
  word-break: normal;
}
ul > li > a{
  color: rgba(255,255,255,0.50);
  text-decoration: none;
}
p{
  color: rgba(255,255,255,0.50);
  text-align: center;
  margin: 0;
  padding: 30px 0;
  border-top: 1px solid rgba(153,153,153,0.50);
}
.footer-bar-row img{
  width: 200px;
  margin-top: 15px;
}
.footer-bar-row p{
  padding: 0;
  padding-top: 10px;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}
</style>

<script>
import FooterBarCopyRight from './FooterBarCopyRight.vue'
export default {
  components: {
    FooterBarCopyRight
  },
  mounted(){
    // var dom=document.createElement('script');
    // dom.src='https://chat8.live800.com/live800/chatClient/floatButton.js?jid=8995057059&companyID=1360507&configID=153644&codeType=custom&ss=1'
    // //dom.innerHTML='hello world'
    // document.body.appendChild(dom)
  }
}
</script>